import * as React from 'react';
import s from './table-kit.module.scss';

// ActionRail — the consistent trailing container for row actions. Replaces
// ad-hoc floating text links / lone kebabs with one aligned rail.
export function ActionRail({ children }: { children: React.ReactNode }) {
  return <span className={s.actionRail}>{children}</span>;
}

type RowActionButtonProps = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  variant?: 'default' | 'primary';
};

// RowActionButton — a real button affordance for a row's primary/secondary
// action (e.g. "Fix"), instead of a bare text link.
export function RowActionButton({
  variant = 'default',
  children,
  ...props
}: RowActionButtonProps) {
  return (
    <button
      type="button"
      className={s.actionButton}
      data-variant={variant === 'primary' ? 'primary' : undefined}
      {...props}
    >
      {children}
    </button>
  );
}
